import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store.js';
import App from './App.vue';
import JQuery from 'jquery';
import VueI18n from 'vue-i18n';
import Meta from 'vue-meta';
import VueScrollactive from 'vue-scrollactive';
window.$ = JQuery.$ = JQuery;
import 'popper.js';
import 'bootstrap';
import '../node_modules/bootstrap/scss/bootstrap.scss';
import '../node_modules/pretty-checkbox/src/pretty-checkbox.scss';
import '../node_modules/slick-carousel/slick/slick.css';
import './styles/app.scss';
import vSelect from 'vue-select';
import VueScrollTo from 'vue-scrollto';

import { he } from './languages/he';
import { en } from './languages/en';

import { sync } from 'vuex-router-sync';
sync(store, router);

import router from './routes.js';

import '../node_modules/animate.css/animate.css';
import '../node_modules/vue-select/src/scss/vue-select.scss';

import AOS from 'aos';
import 'aos/dist/aos.css';

import VueSweetAlert from 'vue-sweetalert'

Vue.component('v-select', vSelect);
Vue.use(VueRouter);
Vue.use(Meta);
Vue.use(VueI18n);

Vue.use(VueSweetAlert);
Vue.use(VueScrollTo);
Vue.use(VueRouter);
Vue.use(VueScrollTo);
Vue.use(VueScrollactive);
Vue.use(Meta);
Vue.use(VueScrollTo);

Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: { he, en }, // set locale messages
});

new Vue({
  created () {
    AOS.init()
  },
  render: h => h(App),
  router,
  store,
  i18n,
}).$mount('#app');
